<div class="invite-page">

  @if (session_id) {
  <div class="thankyou">
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="47" viewBox="0 0 65 67" fill="none">
      <path d="M32.5 5.58331C17.55 5.58331 5.41666 18.09 5.41666 33.5C5.41666 48.91 17.55 61.4166 32.5 61.4166C47.45 61.4166 59.5833 48.91 59.5833 33.5C59.5833 18.09 47.45 5.58331 32.5 5.58331ZM32.5 55.8333C20.5562 55.8333 10.8333 45.8112 10.8333 33.5C10.8333 21.1887 20.5562 11.1666 32.5 11.1666C44.4437 11.1666 54.1667 21.1887 54.1667 33.5C54.1667 45.8112 44.4437 55.8333 32.5 55.8333ZM43.0083 23.1429L27.0833 39.5579L21.9917 34.3096C20.9354 33.2208 19.2292 33.2208 18.1729 34.3096C17.1167 35.3983 17.1167 37.1571 18.1729 38.2458L25.1875 45.4762C26.2437 46.565 27.95 46.565 29.0062 45.4762L46.8542 27.0791C47.9104 25.9904 47.9104 24.2316 46.8542 23.1429C45.7979 22.0541 44.0646 22.0541 43.0083 23.1429Z" fill="#488A3B"/>
    </svg>
    <h1 class="title">Thank you!</h1>
  </div>
  <div class="payment-confirmation">
    <p> Your payment succeeded. Now, let's send some invites!</p>
  </div>

} @else {
  <h1 class="title">
    Send an Invite
  </h1>
}
  <div class="custom-line">
    <hr />
  </div>

  <div class="step1" [formGroup]="form">
    <h2 class="step1-title"> Step 1: Pick An Assessment</h2>

    @if (loadingInventory) {
      <div class="loading-container">
        <mat-spinner diameter="35"></mat-spinner>
      </div>
    } @else {
      @if (assessments.length === 1) {
        <mat-form-field class="assessments-dropdown" appearance="outline">
          <input matInput 
                 style="font-weight: 500; cursor: pointer;"
                 [placeholder]="assessments[0].name" 
                 readonly
                 data-testid="invite-single-assessment-input">
          <mat-label style="font-weight: 500;">{{ assessments[0].name }}</mat-label>
        </mat-form-field>
      } @else if (assessment_id && !this.session_id) {
        @if (assessment_name) {
          <mat-form-field class="assessments-dropdown" appearance="outline" floatLabel="always">
            <mat-label style="font-weight: 500;">Assessment Name</mat-label>
            <div class="assessment-wrapper">
              <div class="assessment-container">
                <input matInput 
                       class="assessment-name"
                       style="font-weight: 500; cursor: default;"
                       [placeholder]="assessment_name.name" 
                       readonly
                       data-testid="invite-assessment-name-input">
                <div class="calculation-assessm">
                  {{ org_inventory?.available_inventory! + parent_org_inventory?.available_inventory! }} Available
                  <mat-icon class="info" 
                            [matTooltip]="formattedTooltip" 
                            matTooltipPosition="above">
                    info_outline
                  </mat-icon>
                </div>
              </div>
            </div>
          </mat-form-field>
        }
      } @else {
        <mat-form-field class="assessments-dropdown" appearance="outline">
          <mat-label style="font-weight: 500;">Select an Assessment</mat-label>
          <mat-select data-testid="invite-assessment-select" formControlName="selected_assessment_id" (selectionChange)="onAssessmentSelected($event)">
            <mat-select-trigger>{{ form.get('selected_assessment_id')?.value.name }}</mat-select-trigger>
            @for (assessment of assessments; track assessment) {
              <mat-option [value]="assessment" (click)="getOrgsAndInventory()">
                <table class="assessment_table">
                  <tr>
                    <td class="assessment_name">{{ assessment.name }}</td>
                    @for (assessment_purchased of assessments_purchased; track assessment_purchased) {
                      @if (assessment.assessment_id === assessment_purchased.assessment_id) {
                        <td class="availability">{{ assessment_purchased.quantity }} new!</td>
                      }
                    }
                  </tr>
                </table>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    }

    @if (session_id) {
      <mat-form-field class="org-dropdown" appearance="outline">
        <mat-label style="font-weight: 500">Select an Organization</mat-label>
        <mat-select data-testid="invite-org-select" formControlName="selected_org_id" (selectionChange)="onOrgSelected($event)">
          <mat-select-trigger>
            <table class="table">
              <tr>
                <td class="org_name"> {{ selectedOrg?.org_name }} </td>
                <td class="calculation"> {{ selectedOrg?.available_inventory! + parent_org_inventory?.available_inventory! }} Available
                  <mat-icon class="info" [matTooltip]="formattedTooltip" matTooltipPosition="above">
                    info_outline
                  </mat-icon>
                </td>
              </tr>
            </table>
          </mat-select-trigger>
          @for (org of orgs; track org) {
            @if (org.level !== null) {
              <mat-option [value]="org">
                <tr>
                  <td class="assessment_name"
                  [style]="{
                    'font-weight': org.level === 0 ? 'bold' : 'normal',
                    'padding-left': org.level === 0 ? '0px' : '20px'
                  }">
                    {{ org.org_name }}
                  </td>
                </tr>
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  <!-- Step 2: Invite Tabs -->
  <div class="step2">
    <h2 class="step2-title">Step 2: Invite</h2>

    <div class="tab-container">
      <button mat-icon-button (click)="prevTab()" [disabled]="selected_tab_index === 0" data-testid="invite-prev-tab-button">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <mat-tab-group [(selectedIndex)]="selected_tab_index" (selectedTabChange)="onTabClicked($event)" class="tabs"
        animationDuration="0ms">
        @if (!hideTab) {
          <!-- "By Link" Tab -->
          <mat-tab class="link-tab" label="By Link" data-testid="invite-by-link-tab">
            <p>Copy the link below to invite people</p>

            <div class="link-tab-wrapper">
              <!-- Show Spinner While Loading -->
              @if (loading) {
                <div class="loading-container">
                  <mat-spinner diameter="35"></mat-spinner>
                </div>
              } @else {
                <!-- Show Link When Loaded -->
                @if (generated_link) {
                  <mat-card appearance="outlined" class="dashed-card">
                    <mat-card-content class="content-container">
                      <div class="link-container">
                        <span class="link-text" data-testid="invite-generated-link">
                          {{ generated_link }}
                        </span>
                        <div class="copy-link" (click)="copyToClipboard(generated_link)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="25" viewBox="0 0 34 35" fill="none">
                            <path
                              d="M21.0141 10.0957C22.5095 10.929 22.9974 12.8583 22.1024 14.3983L20.0087 18.0007L21.6702 18.9267L23.7638 15.3242C25.2085 12.8386 24.4221 9.72957 22.0086 8.38453C19.5951 7.03949 16.4639 7.96523 15.0193 10.4509L12.9256 14.0533L14.5871 14.9793L16.6807 11.3768C17.5758 9.8368 19.5188 9.26235 21.0141 10.0957ZM17.9937 13.3009L13.8063 20.5057L15.5553 21.4804L19.7426 14.2755L17.9937 13.3009ZM18.5297 24.3303L20.6233 20.7279L18.9619 19.802L16.8682 23.4044C15.9731 24.9444 14.0301 25.5189 12.5348 24.6856C11.0395 23.8522 10.5515 21.923 11.4466 20.3829L13.5402 16.7805L11.8788 15.8546L9.7851 19.457C8.34047 21.9427 9.12679 25.0517 11.5403 26.3967C13.9538 27.7418 17.085 26.816 18.5297 24.3303Z"
                              fill="#1C69F9" />
                          </svg>
                          <span class="copy-link-text">Copy Link</span>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                } @else {
                  <mat-card appearance="outlined" class="dashed-card">
                    <mat-card-content class="content-container">
                      <p class="pre-link-text">
                        Please fill in all required fields above to generate link.
                      </p>
                    </mat-card-content>
                  </mat-card>
                }
              }
            </div>
          </mat-tab>
        }

        <mat-tab label="By Email or &#64;mention">
          <mat-form-field appearance="outline" class="email-mention">
            <mat-label class="email-label">
              Add multiple &#64;mentions or email addresses
            </mat-label>
            <mat-chip-grid #chipGrid>
              @for (chip of selected_chips; track chip) {
                <mat-chip-row (removed)="removeChip(chip)">
                  {{ chip }}
                  <button matChipRemove [attr.data-testid]="'invite-mention-chip-remove-' + chip">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
              @for (chip of selected_email_chips; track chip) {
                <mat-chip-row (removed)="removeChip(chip)">
                  {{ chip }}
                  <button matChipRemove [attr.data-testid]="'invite-email-chip-remove-' + chip">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
              @for (chip of selected_unregistered_email_chips; track chip) {
                <mat-chip-row (removed)="removeChip(chip)">
                  {{ chip }}
                  <button matChipRemove [attr.data-testid]="'invite-unregistered-email-chip-remove-' + chip">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
              <input
              class="form-input"
              #chipInput
              matInput
              placeholder="Press enter or space to save input."
              [formControl]="chipControl"
              [matChipInputFor]="chipGrid"
              [matAutocomplete]="auto"
              [matChipInputSeparatorKeyCodes]="separator_keys_codes"
              (matChipInputTokenEnd)="addChip($event)"
              data-testid="invite-mention-chip-input"
              />
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event)">
              @for (option of filteredOptions | async; track option) {
                <mat-option [value]="option" >
                  {{ option.first_name }} {{ option.last_name }} </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </mat-tab>
        
        <mat-tab label="By Cohort">
          <mat-form-field class="cohort-dropdown" appearance="outline" [formGroup]="form">
            <mat-label>Select a Cohort</mat-label>
            <mat-select formControlName="cohort_id">
              @for (cohort of cohorts; track cohort) {
                <mat-option [value]="cohort.id">{{cohort.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field> 
        </mat-tab>
      </mat-tab-group>
      <button mat-icon-button (click)="nextTab()" [disabled]="selected_tab_index === tabCount - 1" data-testid="invite-next-tab-button">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>

  <div class="step3">
    @if (this.checkTab() !== TAB_INDEXES.LINK) {
      
      <h2 class="step3-title"> Step 3: Select a Date (Optional)</h2>
      <p>Select an Assessment Due Date</p>
  
      <mat-form-field class="date" appearance="outline" [formGroup]="form">
        <mat-label class="date-label">Select Date</mat-label>
        <input matInput formControlName="close_dt" [matDatepicker]="picker" data-testid="invite-close-date-input">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    }
  </div>

  @if (this.checkTab() !== TAB_INDEXES.LINK) {
    <div class="invite-container">
      <button class="invite" mat-button (click)="invite()" data-testid="invite-submit-button">
        Invite
      </button>
    </div>
  } @else {
    <div class="home-container">
      <div class="home" style="color: #1C69F9 " (click)="goHome()">
        <mat-icon class="arrow">arrow_back</mat-icon>
        Back to Home
      </div>    
    </div>
  }


</div>
